import {
    TERM_LIST_REQUEST,
    TERM_LIST_SUCCESS,
    TERM_LIST_FAIL,
    TERM_LIST_RESET,
} from '../constants/TermListConstants'

export const TermListReducer = (state = { termlists: [] }, action) => {
    switch (action.type) {
        case TERM_LIST_REQUEST:
            return { loading: true };
        case TERM_LIST_SUCCESS:
            return { loading: false, termlists: action.payload }
        case TERM_LIST_FAIL:
            return { loading: false, error: action.payload }
        case TERM_LIST_RESET:
            return { loading: false, error: '', termlists:[] }
        default:
            return state;
    }
}
